import type { RouteLocationRaw, Router } from 'vue-router';

/** Подпись внизу каждого печатного листа и наклейки. */
export const PRINT_SIGNATURE = 'mors.pro · автоматизация бизнеса';

/** Печатная форма открывается в новой вкладке: карточка остаётся на экране. */
export const openPrint = (router: Router, to: RouteLocationRaw): void => {
  window.open(router.resolve(to).href, '_blank');
};
